import MarketExecutiveSpiderDashboardController from 'lumen/controllers/market/executive/spider-dashboard';

export default class MarketSegmentDrilldownController extends MarketExecutiveSpiderDashboardController {}
